
import { Vue, Component, Ref } from 'vue-property-decorator';
// import VehicleModule from '@/components/carModule/VehicleModule.vue';
import SPUcar from '@/components/carModule/SPUcar.vue';
import { CarFieldFactory } from '@/models/carFieldFactory';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import { JCarSPU, CarSPU } from '@/models/car.model';
// import { CarSPU } from '@/models/car.model';
import carTableList from '../components/carTableList.vue';

@Component({
  components: {
    // VehicleModule,
    SPUcar,
    carTableList,
  },
})
export default class CarList extends Vue {
  @Ref()
  spuCar!: SPUcar;

  @Ref()
  carList!: carTableList;

  @lazyInject(CarService)
  CarService!: CarService;


  columns = [
    {
      dataIndex: 'id',
      key: 'id',
      align: 'center',
    },
    {
      title: '车辆图片',
      dataIndex: 'car_image',
      key: 'car_image',
      align: 'center',
      scopedSlots: { customRender: 'car_image' },

    },
    {
      title: '品牌',
      dataIndex: 'series',
      key: 'series',
      align: 'center',
    },
    {
      title: '车系',
      key: 'model_name',
      dataIndex: 'model_name',
      align: 'center',
    },
    {
      title: '所在地',
      key: 'car_location',
      dataIndex: 'car_location',
      align: 'center',
    },
    {
      title: '排量',
      key: 'liter',
      dataIndex: 'liter',
      align: 'center',
    },
    {
      title: '变速箱',
      key: 'gear_name',
      dataIndex: 'gear_name',
      align: 'center',
    },
    {
      title: '首次上牌',
      key: 'first_registration_date',
      dataIndex: 'first_registration_date',
      align: 'center',
    },
    {
      title: '表显里程(万公里)',
      key: 'mileage',
      dataIndex: 'mileage',
      align: 'center',
    },
    {
      title: '创建时间',
      key: 'created_at',
      dataIndex: 'created_at',
      align: 'center',
    },
    {
      title: '修改时间',
      key: 'updated_at',
      dataIndex: 'updated_at',
      align: 'center',
    },
    {
      title: '状态',
      key: 'online',
      dataIndex: 'online',
      align: 'center',
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];

  shopId = '';

  copyVisible = false;

  dataSource = [];

  async addCarCommodity(form: any) {
    const r = JCarSPU.form(form);
    r.shop_id = Number(this.$route.params.id);
    // console.log(r);
    if (r.id === 0) {
      const res = await this.CarService.addCarCommodity(r);
      if (res) {
        this.$message.success('添加成功');
        this.spuCar.onClose();
        this.init();
      }
    } else {
      r.commodity_code = this.commodityCode;
      const res = await this.CarService.updateCarCommodity(r);
      if (res) {
        this.$message.success('编辑成功');
        this.commodityCode = '';
        this.spuCar.onClose();
        this.init();
      }
    }
  }
  open() {
    const carFields = CarFieldFactory.init({ spuType: 'car' });
    // console.log(carFields);
    this.spuCar.open();
    const form = new CarSPU();
    this.spuCar.setup(carFields, form);
  }

  // setup() {
  //   this.spuCar.setup([], {});
  // }
  commodityCode = '';

  async editor(val: any) {
    // console.log(val);
    const p = {
      code: val.commodity_code,
    };
    this.commodityCode = val.commodity_code;
    const res = await this.CarService.getCarCommodityDetail(p);
    const carFields = CarFieldFactory.init({ spuType: 'car' });
    this.spuCar.open();
    const form = CarSPU.form(res);
    // console.log(form);
    this.spuCar.setup(carFields, form);
  }
  refreshGoods() {
    this.init();
  }
  async init() {
    this.$nextTick(() => {
      this.carList.init(this.shopId);
    });
  }

  /**
   * 车源配置
   */
  async getCarConfig() {
    const res = await this.CarService.getCarConfig();
    // console.log(res);
    localStorage.setItem('carFields', JSON.stringify(res));
  }

  mounted() {
    const { id } = this.$route.params;
    this.shopId = id;
    this.init();
    this.getCarConfig();
  }
}
